export function getFormattedIntegerValues(number) {
    return new Intl.NumberFormat('en-US').format(number);
}
